import RfiAnalyticsUploaderInstance from './RfiAnalyticsUploaderInstance.component';

export default RfiAnalyticsUploaderInstance;